<template>
  <div class="promptMediasBulkDeletion">
    <p>
      Êtes-vous sûr de vouloir supprimer les
      {{ mediasIds.length }} sélectionné(s) ?
    </p>
    <e-button @click.native.prevent="$emit('confirm')">Confirmer</e-button>
    <e-button @click.native.prevent="$emit('cancel')">Annuler</e-button>
  </div>
</template>

<script>
export default {
  props: {
    mediasIds: {
      type: () => [],
      required: true
    }
  }
}
</script>

<style lang="scss">
.promptMediasBulkDeletion {
  background-color: var(--white);
  display: inline-block;
  padding: var(--spacing-xl);
  text-align: center;
  border: 1px solid var(--black);

  p {
    margin-top: 0;
    line-height: 1.5em;
  }
}
</style>
